import * as API from './index'

export default {
    import: params => {
        return API.POSTFORM('/api/ScheduleDetail/Import', params)
    },
    download: params => {
        return API.GETBlog('/api/ScheduleDetail/Export', params)
    }, getList: params => {
        return API.GET('/api/ScheduleDetail/List', params)
    },
    delete: params => {
        return API.DELETE('/api/ScheduleDetail/delete', params)
    },
    deleteMatch: params => {
        return API.DELETE('/api/ScheduleDetail/deleteMatch', params)
    },
    deleteBatch: params => {
        return API.DELETEBATCH('/api/ScheduleDetail/DeleteBatch', params)
    }
}


// WEBPACK FOOTER //
// ./src/apis/scheduledetail.js